<template>
    <div class="modal fade" id="joinTeamVolunteerModal" ref="joinTeamVolunteerModal" tabindex="-1" role="dialog" aria-labelledby="joinTeamVolunteerModalLabel" aria-hidden="true">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header" style="padding-bottom: 0;">
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <img src="./../../assets/ics.svg" alt="ics" />
                    </button>
                </div>
                <div class="modal-body" style="padding-top: 0;">
                    <div class="row">
                        <div class="col-12">
                            <h5 class="modal-title" id="joinTeamVolunteerModalLabel">{{ $t('join_team.title') }}</h5>
                        </div>
                        <div class="col-12 mt-3">
                            <span class="detail-data canvassing-color-black"><span class="weight-500">{{ person.name }}</span> {{ $t('join_team.wants_to_join') }} <span class="weight-500">{{ currentCampaignComputed }}</span></span>
                        </div>
                        <div class="col-12 mt-2">
                            <span class="detail-data canvassing-color-black"> {{ $t('join_team.wants_to_work') }} <span class="weight-500">{{ person.user_area }}</span></span>
                        </div>
                        <div class="col-12 mt-2">
                            <button @click.prevent="doAddVolunteer" class="btn shadow btn-app btn-block mb-3 mt-3 primaryBackground" id="join">{{ $t('join_team.add_volunteer') }}</button>
                            <div v-if="hasError(errors, 'join')">
                                <span class="text-danger">{{errors.join[0]}}</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-footer modal-footer-canvassing-redish">
                    <span class="text-center w-100" id="reject">{{ $t('join_team.reason') }}</span>
                    <div v-if="hasError(errors, 'reject')" class="w-100">
                        <span class="text-danger d-block w-100 text-center">{{errors.reject[0]}}</span>
                    </div>
                    <textarea class="reject-textarea w-100" id="reject" rows="4" cols="50" v-model="rejectMessage">
                    </textarea>
                    <span @click.prevent="doRejectVolunteer" class="modal-footer-canvassing-red-button mt-3 mx-auto cursor-pointer">{{ $t('join_team.reject') }}</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import HelperMixin from "../../mixins/HelperMixin";

    export default {
        name: "JoinTeamVolunteerModal",
        props: ["person"],
        mixins: [HelperMixin],
        data() {
            return {
                rejectMessage: '',
                errors: {
                    join: [],
                    reject: []
                }
            }
        },
        created() {
                      
        },
        mounted() {
            $(this.$refs['joinTeamVolunteerModal']).on('hide.bs.modal', this.resetModal);
        },
        computed: {
            currentCampaignComputed() {
                return this.$store.getters["currentCampaign"] ? this.$store.getters["currentCampaign"].name : ''
            },
        },
        methods: {
            resetModal() {
                this.errors = {
                    join: [],
                    reject: []
                };
                this.rejectMessage = '';
            },

            dismissDetails() {
                $('#joinTeamVolunteerModal').modal('hide');
            },

            doAddVolunteer() {
                this.errors = {
                    join: [],
                    reject: []
                };
                this.$store.dispatch('saveIsLoading', {
                    isLoading: true
                });
                let config = {
                    headers: {
                        'Authorization': `Bearer ${this.$store.getters["token"]}`,
                    }
                };

                axios.post(
                    '/api/v1/campaign/' + this.$route.params.campaign_id + '/user/' + this.person._id + '/accept',
                        {},
                        config
                ).then(this.consumedoAddVolunteer, this.errordoAddVolunteer);
            },

            consumedoAddVolunteer: function (response) {
                this.$store.dispatch('saveIsLoading', {
                    isLoading: false
                });
                this.dismissDetails();
                this.$router.go();
            },

            errordoAddVolunteer: function (error) {
                this.errors.join = [this.$t('join_team.errors.join_error')];
                this.$store.dispatch('saveIsLoading', {
                    isLoading: false
                });
               console.log(error);
            },

            doRejectVolunteer() {
                this.errors = {
                    join: [],
                    reject: []
                };
                this.$store.dispatch('saveIsLoading', {
                    isLoading: true
                });
                let config = {
                    headers: {
                        'Authorization': `Bearer ${this.$store.getters["token"]}`,
                    }
                };

                axios.post(
                    '/api/v1/campaign/' + this.$route.params.campaign_id + '/user/' + this.person._id + '/reject',
                        {
                            message: this.rejectMessage
                        },
                        config
                ).then(this.consumedoRejectVolunteer, this.errordoRejectVolunteer);
            },

            consumedoRejectVolunteer: function (response) {
                this.$store.dispatch('saveIsLoading', {
                    isLoading: false
                });
                this.dismissDetails();
                this.$router.go();
            },

            errordoRejectVolunteer: function (error) {
                if (
                    error.response !== undefined &&
                    error.response.data !== undefined &&
                    error.response.data.responseType === 'Error' &&
                    error.response.data.errorMessage !== undefined 
                ) {
                    if (typeof error.response.data.errorMessage.validation_fail != 'undefined') {
                        if (typeof error.response.data.errorMessage.validation_fail.message != 'undefined') {
                            if (error.response.data.errorMessage.validation_fail.message.includes("required")) {
                                this.errors.reject = [this.$t('join_team.errors.reject_required')];
                            }
                            if (error.response.data.errorMessage.validation_fail.message.includes("min")) {
                                this.errors.reject = [this.$t('join_team.errors.reject_min')];
                            }
                            if (error.response.data.errorMessage.validation_fail.message.includes("max")) {
                                this.errors.reject = [this.$t('join_team.errors.reject_max')];
                            }
                        }
                    }
                } else {
                    this.errors.reject = [this.$t('join_team.errors.reject_error')];
                }

    
                this.$store.dispatch('saveIsLoading', {
                    isLoading: false
                });
               console.log(error);
            },
        },
    };
</script>
